var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgK1BarCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 54a4 4 0 01-4 4H12a4 4 0 01-4-4V20a4 4 0 014-4h52a4 4 0 014 4v34zm-4 0V20H12v34h52zM53 26v22h6V26h-6zm-6 0v22h3V26h-3zm-9 0v22h6V26h-6zm-6 0v22h3V26h-3zm-6 0v22h3V26h-3zm-9 0v22h6V26h-6z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/K1_Bar_code.fff8990b.svg";
export { SvgK1BarCode as ReactComponent };